import React, { FC, FormEvent, useEffect, useState, useContext } from "react"
import PasswordRequirements from "../../components/account-settings/PasswordRequirements"
import SecurePassword from "../../components/authentication/SecurePassword"
import useLoading from "../../hooks/useLoading"
import { Button } from "../../components/ui/button"
import { EmailLogin } from "../../api/auth.service"
import { Input } from "../../components/ui/input"
import { Link, useNavigate } from "react-router-dom"
import {
  SvgChevronLeft,
  SvgZoeeLogoColored,
  SvgChevronRight,
} from "../../components/icons"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

export default function ResetPasswordPage() {
  const { user } = useContext(UserCtx)
  const { startLoading, stopLoading } = useLoading()
  const [newPassword, setNewPassword] = useState<string>("")
  const [confirmPassword, setConfirmPassword] = useState<string>("")
  const [formErrors, setFormErrors] = useState<any>({})
  const [isSubmit, setIsSubmit] = useState<boolean>(false)
  const [code, setCode] = useState<string>("")
  const [validPasswordChars, setValidPasswordChars] = useState<boolean>(false)
  const [showPassReq, setShowPassReq] = useState(false)
  const [validEntree, setValidEntree] = useState<string>("")
  const [redirectPath, setRedirectPath] = useState<string>("")
  const { toast } = useToast()
  const isTemp = localStorage.getItem("isTemp")
  const memberRedirect = localStorage.getItem("memberRedirect") || "/member"
  const coachRedirect = localStorage.getItem("coachRedirect") || "/coach"
  const navigate = useNavigate()

  const validateForm = () => {
    const errors: any = {}
    ;(!newPassword || !validPasswordChars) &&
      (errors.password = "Valid password is required")
    ;(!confirmPassword || confirmPassword !== newPassword) &&
      (errors.confirmPassword = "Password must match")
    return errors
  }

  const validateCharacters = (pswd: string) => {
    var pattern = /^(?=.*\d)(?=.*[^a-zA-Z0-9])(?=.*[A-Z])(?=.*[a-z]).{8,}$/
    setValidEntree(pswd)
    if (pswd.match(pattern)) {
      setValidPasswordChars(true)
    } else {
      setValidPasswordChars(false)
    }
  }

  const handleSubmit = (e: FormEvent<EventTarget>) => {
    e.preventDefault()
    const errors = validateForm()
    setFormErrors(errors)
    setIsSubmit(true)
  }

  const redirectURL = () => {
    localStorage.removeItem("isTemp")
    const path =
      user?.activeProfile === "coach" ? coachRedirect : memberRedirect
    navigate(path)
  }

  const navigateHome = () => {
    localStorage.removeItem("isTemp")
    navigate("/")
  }

  const createNewPassword = () => {
    if ((code && newPassword) || (isTemp === "true" && newPassword)) {
      EmailLogin.resetPasswordChangePassword({
        email: user?.email || "",
        verification_code: code,
        password: newPassword,
      })
        .then((data) => {
          if (!user) {
            toast.success("Password successfully changed. Please sign in.")
            redirectURL()
          } else {
            toast.success("Password successfully created.")
            redirectURL()
          }
        })
        .catch((ex) => {
          console.warn(ex)
        })
        .finally(() => {
          stopLoading()
        })
    }
  }

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors).length === 0) {
      startLoading()
      setIsSubmit(false)
      createNewPassword()
    } else {
      setIsSubmit(false)
      stopLoading()
    }
  }, [formErrors])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get("t")
    setRedirectPath(params.get("redirectPath") as string)
    if (code) {
      setCode(code)
    } else {
      navigate(redirectPath)
    }
  }, [])

  return (
    <div className="flex items-center justify-center bg-gradient-to-b from-[#8A90FF] via-[#4750F5] to-[#292F8F] h-screen w-full p-2">
      {" "}
      <div className="flex items-center justify-center flex-col w-[90%] sm:w-[50%] md:mt-4 bg-white rounded-xl p-6">
        <SvgZoeeLogoColored className="mb-8 mt-8 h-10 " />
        <div className="w-[360px] md:w-[480px] flex flex-col items-center">
          <div className="font-semibold text-[32px] mb-[40px]">
            Set New Password
          </div>
          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-[70%] mb-12 gap-6"
          >
            {showPassReq && (
              <PasswordRequirements
                validEntree={validEntree}
                bottomMargin="0"
              />
            )}
            <Input
              label="New Password"
              placeholder="Enter New Password"
              type="password"
              error={formErrors.password}
              id="createPassword"
              name="createPassword"
              onChange={({ target: { value } }) => {
                validateCharacters(value)
                setNewPassword(value)
              }}
              value={newPassword}
              onFocus={() => setShowPassReq(true)}
              onBlur={() => setShowPassReq(false)}
            />
            <SecurePassword password={newPassword} />
            <Input
              label="Confirm Password"
              placeholder="Confirm your Password"
              type="password"
              error={formErrors.confirmPassword}
              id="confirmPassword"
              name="confirmPassword"
              onChange={({ target: { value } }) => setConfirmPassword(value)}
              value={confirmPassword}
            />
            <Button type="submit">Continue</Button>
          </form>
          <div className="flex gap-4 mb-4">
            {!isTemp || !user ? (
              <button
                onClick={navigateHome}
                className="flex items-center gap-2 transition-transform duration-200 hover:scale-105"
              >
                <SvgChevronLeft />
                Home
              </button>
            ) : (
              <Link
                to={
                  user.activeProfile === "coach"
                    ? coachRedirect
                    : memberRedirect
                }
                className="flex items-center gap-2 transition-transform duration-200 hover:scale-105"
              >
                Skip
                <SvgChevronRight />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
